// Stop a FAQ answer's YouTube video when its accordion row is closed.
// The iframe is removed and deferred-media is reset, so nothing keeps playing
// hidden (a pause message sent before the player is ready would be dropped)
// and the next click on the poster loads the video again.
// toggle doesn't bubble, so listen in the capture phase.
if (!window.collapsibleContentVideo) {
  window.collapsibleContentVideo = true;

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || details.open) return;

      details.querySelectorAll('.accordion__video deferred-media[loaded]').forEach((media) => {
        media.querySelectorAll('iframe').forEach((iframe) => iframe.remove());
        media.removeAttribute('loaded');
      });
    },
    true
  );
}
